import * as Yup from "yup";
import React from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  selectValidation,
  stringValidation,
  fileValidation,
  arrayValidation,
} from "../providers/validations";
import Field from "../components/Field";
import { FileUpload, Select, Text } from "../inputs";
import { Form } from "../template";
import { SHA256 } from "crypto-js";
import { mainApi } from "../providers/api";
import objectPath from "object-path";
import { classificationType } from "../type/Form";

const UserForm = () => {
  const { t } = useTranslation();
  const { id } = useParams();

  const props = {
    editable: true,
    isDeletable: true,
    model: "advice",
    text: id ? "Зөвлөгөө мэдээлэл" : "Зөвлөгөө бүртгэх",
    id: id,
    init: {},
    validationSchema: Yup.object().shape({
      file: fileValidation(true),
      title: stringValidation(true),
    }),
  };
  const beforeSubmit = async (data) => {
    return data;
  };

  return (
    <Form {...props} beforeSubmit={beforeSubmit}>
      {({ submited, disabled, values }) => {
        return (
          <div className="p-5 bg-white  grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="flex flex-col gap-4">
              <Field
                name="file"
                label={t("advice.file")}
                disabled={disabled}
                component={FileUpload}
                type="text"
                className={`text-black `}
              />
            </div>
            <div className="flex flex-col gap-4 min-h-screen">
              <Field
                name="title"
                label={t("advice.title")}
                disabled={disabled}
                component={Text}
                type="text"
              />
              <Field
                name="link"
                label={t("advice.link")}
                disabled={disabled}
                component={Text}
                type="text"
              />
              <Field
                name="description"
                label={t("advice.description")}
                disabled={disabled}
                component={Text}
                type="textarea"
              />
            </div>
          </div>
        );
      }}
    </Form>
  );
};

export default UserForm;
